import _classCallCheck from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Util } from '../Util.js';
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { getNumberValidator, getStringValidator, getNumberOrAutoValidator, getBooleanValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
export function stringToArray(string) {
  return Array.from(string);
}
var AUTO = 'auto',
    CENTER = 'center',
    JUSTIFY = 'justify',
    CHANGE_KONVA = 'Change.konva',
    CONTEXT_2D = '2d',
    DASH = '-',
    LEFT = 'left',
    TEXT = 'text',
    TEXT_UPPER = 'Text',
    TOP = 'top',
    BOTTOM = 'bottom',
    MIDDLE = 'middle',
    NORMAL = 'normal',
    PX_SPACE = 'px ',
    SPACE = ' ',
    RIGHT = 'right',
    WORD = 'word',
    CHAR = 'char',
    NONE = 'none',
    ELLIPSIS = '…',
    ATTR_CHANGE_LIST = ['fontFamily', 'fontSize', 'fontStyle', 'fontVariant', 'padding', 'align', 'verticalAlign', 'lineHeight', 'text', 'width', 'height', 'wrap', 'ellipsis', 'letterSpacing'],
    attrChangeListLen = ATTR_CHANGE_LIST.length;

function normalizeFontFamily(fontFamily) {
  return fontFamily.split(',').map(function (family) {
    family = family.trim();
    var hasSpace = family.indexOf(' ') >= 0;
    var hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;

    if (hasSpace && !hasQuotes) {
      family = "\"".concat(family, "\"");
    }

    return family;
  }).join(', ');
}

var dummyContext;

function getDummyContext() {
  if (dummyContext) {
    return dummyContext;
  }

  dummyContext = Util.createCanvasElement().getContext(CONTEXT_2D);
  return dummyContext;
}

function _fillFunc(context) {
  context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}

function _strokeFunc(context) {
  context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}

function checkDefaultFill(config) {
  config = config || {};

  if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) {
    config.fill = config.fill || 'black';
  }

  return config;
}

export var Text =
/*#__PURE__*/
function (_Shape) {
  _inherits(Text, _Shape);

  function Text(config) {
    var _this;

    _classCallCheck(this, Text);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, checkDefaultFill(config)));
    _this._partialTextX = 0;
    _this._partialTextY = 0;

    for (var n = 0; n < attrChangeListLen; n++) {
      _this.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, _this._setTextData);
    }

    _this._setTextData();

    return _this;
  }

  _createClass(Text, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var textArr = this.textArr,
          textArrLen = textArr.length;

      if (!this.text()) {
        return;
      }

      var padding = this.padding(),
          fontSize = this.fontSize(),
          lineHeightPx = this.lineHeight() * fontSize,
          verticalAlign = this.verticalAlign(),
          alignY = 0,
          align = this.align(),
          totalWidth = this.getWidth(),
          letterSpacing = this.letterSpacing(),
          fill = this.fill(),
          textDecoration = this.textDecoration(),
          shouldUnderline = textDecoration.indexOf('underline') !== -1,
          shouldLineThrough = textDecoration.indexOf('line-through') !== -1,
          n;
      var translateY = 0;
      var translateY = lineHeightPx / 2;
      var lineTranslateX = 0;
      var lineTranslateY = 0;
      context.setAttr('font', this._getContextFont());
      context.setAttr('textBaseline', MIDDLE);
      context.setAttr('textAlign', LEFT);

      if (verticalAlign === MIDDLE) {
        alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
      } else if (verticalAlign === BOTTOM) {
        alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
      }

      context.translate(padding, alignY + padding);

      for (n = 0; n < textArrLen; n++) {
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        var obj = textArr[n],
            text = obj.text,
            width = obj.width,
            lastLine = obj.lastInParagraph,
            spacesNumber,
            oneWord,
            lineWidth;
        context.save();

        if (align === RIGHT) {
          lineTranslateX += totalWidth - width - padding * 2;
        } else if (align === CENTER) {
          lineTranslateX += (totalWidth - width - padding * 2) / 2;
        }

        if (shouldUnderline) {
          context.save();
          context.beginPath();
          context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
          spacesNumber = text.split(' ').length - 1;
          oneWord = spacesNumber === 0;
          lineWidth = align === JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
          context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
          context.lineWidth = fontSize / 15;
          context.strokeStyle = fill;
          context.stroke();
          context.restore();
        }

        if (shouldLineThrough) {
          context.save();
          context.beginPath();
          context.moveTo(lineTranslateX, translateY + lineTranslateY);
          spacesNumber = text.split(' ').length - 1;
          oneWord = spacesNumber === 0;
          lineWidth = align === JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
          context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
          context.lineWidth = fontSize / 15;
          context.strokeStyle = fill;
          context.stroke();
          context.restore();
        }

        if (letterSpacing !== 0 || align === JUSTIFY) {
          spacesNumber = text.split(' ').length - 1;
          var array = stringToArray(text);

          for (var li = 0; li < array.length; li++) {
            var letter = array[li];

            if (letter === ' ' && !lastLine && align === JUSTIFY) {
              lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
            }

            this._partialTextX = lineTranslateX;
            this._partialTextY = translateY + lineTranslateY;
            this._partialText = letter;
            context.fillStrokeShape(this);
            lineTranslateX += this.measureSize(letter).width + letterSpacing;
          }
        } else {
          this._partialTextX = lineTranslateX;
          this._partialTextY = translateY + lineTranslateY;
          this._partialText = text;
          context.fillStrokeShape(this);
        }

        context.restore();

        if (textArrLen > 1) {
          translateY += lineHeightPx;
        }
      }
    }
  }, {
    key: "_hitFunc",
    value: function _hitFunc(context) {
      var width = this.getWidth(),
          height = this.getHeight();
      context.beginPath();
      context.rect(0, 0, width, height);
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "setText",
    value: function setText(text) {
      var str = Util._isString(text) ? text : text === null || text === undefined ? '' : text + '';

      this._setAttr(TEXT, str);

      return this;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
      return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      var isAuto = this.attrs.height === AUTO || this.attrs.height === undefined;
      return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
  }, {
    key: "getTextWidth",
    value: function getTextWidth() {
      return this.textWidth;
    }
  }, {
    key: "getTextHeight",
    value: function getTextHeight() {
      Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
      return this.textHeight;
    }
  }, {
    key: "measureSize",
    value: function measureSize(text) {
      var _context = getDummyContext(),
          fontSize = this.fontSize(),
          metrics;

      _context.save();

      _context.font = this._getContextFont();
      metrics = _context.measureText(text);

      _context.restore();

      return {
        width: metrics.width,
        height: fontSize
      };
    }
  }, {
    key: "_getContextFont",
    value: function _getContextFont() {
      return this.fontStyle() + SPACE + this.fontVariant() + SPACE + (this.fontSize() + PX_SPACE) + normalizeFontFamily(this.fontFamily());
    }
  }, {
    key: "_addTextLine",
    value: function _addTextLine(line) {
      if (this.align() === JUSTIFY) {
        line = line.trim();
      }

      var width = this._getTextWidth(line);

      return this.textArr.push({
        text: line,
        width: width,
        lastInParagraph: false
      });
    }
  }, {
    key: "_getTextWidth",
    value: function _getTextWidth(text) {
      var letterSpacing = this.letterSpacing();
      var length = text.length;
      return getDummyContext().measureText(text).width + (length ? letterSpacing * (length - 1) : 0);
    }
  }, {
    key: "_setTextData",
    value: function _setTextData() {
      var lines = this.text().split('\n'),
          fontSize = +this.fontSize(),
          textWidth = 0,
          lineHeightPx = this.lineHeight() * fontSize,
          width = this.attrs.width,
          height = this.attrs.height,
          fixedWidth = width !== AUTO && width !== undefined,
          fixedHeight = height !== AUTO && height !== undefined,
          padding = this.padding(),
          maxWidth = width - padding * 2,
          maxHeightPx = height - padding * 2,
          currentHeightPx = 0,
          wrap = this.wrap(),
          shouldWrap = wrap !== NONE,
          wrapAtWord = wrap !== CHAR && shouldWrap,
          shouldAddEllipsis = this.ellipsis();
      this.textArr = [];
      getDummyContext().font = this._getContextFont();
      var additionalWidth = shouldAddEllipsis ? this._getTextWidth(ELLIPSIS) : 0;

      for (var i = 0, max = lines.length; i < max; ++i) {
        var line = lines[i];

        var lineWidth = this._getTextWidth(line);

        if (fixedWidth && lineWidth > maxWidth) {
          while (line.length > 0) {
            var low = 0,
                high = line.length,
                match = '',
                matchWidth = 0;

            while (low < high) {
              var mid = low + high >>> 1,
                  substr = line.slice(0, mid + 1),
                  substrWidth = this._getTextWidth(substr) + additionalWidth;

              if (substrWidth <= maxWidth) {
                low = mid + 1;
                match = substr;
                matchWidth = substrWidth;
              } else {
                high = mid;
              }
            }

            if (match) {
              if (wrapAtWord) {
                var wrapIndex;
                var nextChar = line[match.length];
                var nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;

                if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
                  wrapIndex = match.length;
                } else {
                  wrapIndex = Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) + 1;
                }

                if (wrapIndex > 0) {
                  low = wrapIndex;
                  match = match.slice(0, low);
                  matchWidth = this._getTextWidth(match);
                }
              }

              match = match.trimRight();

              this._addTextLine(match);

              textWidth = Math.max(textWidth, matchWidth);
              currentHeightPx += lineHeightPx;

              if (!shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
                var lastLine = this.textArr[this.textArr.length - 1];

                if (lastLine) {
                  if (shouldAddEllipsis) {
                    var haveSpace = this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth;

                    if (!haveSpace) {
                      lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
                    }

                    this.textArr.splice(this.textArr.length - 1, 1);

                    this._addTextLine(lastLine.text + ELLIPSIS);
                  }
                }

                break;
              }

              line = line.slice(low);
              line = line.trimLeft();

              if (line.length > 0) {
                lineWidth = this._getTextWidth(line);

                if (lineWidth <= maxWidth) {
                  this._addTextLine(line);

                  currentHeightPx += lineHeightPx;
                  textWidth = Math.max(textWidth, lineWidth);
                  break;
                }
              }
            } else {
              break;
            }
          }
        } else {
          this._addTextLine(line);

          currentHeightPx += lineHeightPx;
          textWidth = Math.max(textWidth, lineWidth);
        }

        if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
          break;
        }

        if (this.textArr[this.textArr.length - 1]) {
          this.textArr[this.textArr.length - 1].lastInParagraph = true;
        }
      }

      this.textHeight = fontSize;
      this.textWidth = textWidth;
    }
  }, {
    key: "getStrokeScaleEnabled",
    value: function getStrokeScaleEnabled() {
      return true;
    }
  }]);

  return Text;
}(Shape);
Text.prototype._fillFunc = _fillFunc;
Text.prototype._strokeFunc = _strokeFunc;
Text.prototype.className = TEXT_UPPER;
Text.prototype._attrsAffectingSize = ['text', 'fontSize', 'padding', 'wrap', 'lineHeight', 'letterSpacing'];

_registerNode(Text);

Factory.overWriteSetter(Text, 'width', getNumberOrAutoValidator());
Factory.overWriteSetter(Text, 'height', getNumberOrAutoValidator());
Factory.addGetterSetter(Text, 'fontFamily', 'Arial');
Factory.addGetterSetter(Text, 'fontSize', 12, getNumberValidator());
Factory.addGetterSetter(Text, 'fontStyle', NORMAL);
Factory.addGetterSetter(Text, 'fontVariant', NORMAL);
Factory.addGetterSetter(Text, 'padding', 0, getNumberValidator());
Factory.addGetterSetter(Text, 'align', LEFT);
Factory.addGetterSetter(Text, 'verticalAlign', TOP);
Factory.addGetterSetter(Text, 'lineHeight', 1, getNumberValidator());
Factory.addGetterSetter(Text, 'wrap', WORD);
Factory.addGetterSetter(Text, 'ellipsis', false, getBooleanValidator());
Factory.addGetterSetter(Text, 'letterSpacing', 0, getNumberValidator());
Factory.addGetterSetter(Text, 'text', '', getStringValidator());
Factory.addGetterSetter(Text, 'textDecoration', '');